import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import leave from '../component/leave.json'

let Dashboard = () => {
  let [data, setData] = useState();

  let navigate = useNavigate();
  let [sel, setSel] = useState("All");
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  let [startdate, setStartdate] = useState();
  let [enddate, setEnddate] = useState();

  let [load, setLoad] = useState(false);

  let [rent, setRent] = useState(0)

  // Function to open the popup
  const openPopup = () => {
    setIsPopupOpen(true);
  };

  // Function to close the popup
  const closePopup = () => {
    setIsPopupOpen(false);
  };

  useEffect(() => {
    Start();
    User()
    // Payment();
    // nerPayment();
  }, []);

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };


  function validateDates(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);

    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      throw new Error("Invalid date format");
    }

    const isSameDay =
      start.getFullYear() === end.getFullYear() &&
      start.getMonth() === end.getMonth() &&
      start.getDate() === end.getDate();

    return isSameDay || start < end;
  }

  let User = async () => {

    let suu = "Success"
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];

    setLoad(true);
    const requestData = {
      enddate: formattedDate,
      startdate: formattedDate,
      sel: suu,
    };

    console.log(requestData, "requestData")

    try {
      const response = await axios.post(
        Base_url + "/admin/admindashboard",
        requestData,
      );

      let parsedata = AesDecrypt(response.data);
      let Jsson = JSON.parse(parsedata);
      console.log(Jsson, "ghbiufibi bvuid");
      if (Jsson.status === true) {
        setData(Jsson)
        let five = 0
        Jsson?.rent?.map((dt, index) => {
          if (dt?.payment_status_msg === "Success") {
            five = Number(dt?.amount) + five

          }
        })

        setRent(five)
      } else {
        alert("Error");
      }

    } catch (error) {
      console.error("Error", error);
    }
    setLoad(false);
  };


  function addWorkingDay(count, leave) {
    // Parse the input date string
    const date = new Date();

    // Initialize the count of days to add
    let addedDays = 0;

    // Helper to format date for comparison
    const formatDate = (d) =>
      d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });

    // Loop until we've added the required number of working days
    while (addedDays < count) {
      date.setDate(date.getDate() + 1); // Add 1 day

      // Check if the day is not Sunday and not in the leave array
      if (date.getDay() !== 0 && !leave.includes(formatDate(date))) {
        addedDays++;
      }
    }

    const targetDate = new Date(date);

    return targetDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }


  function newaddWorkingDayt3(count, twoo,) {
    let currentDate = new Date(); // Start with today's date
    let daysAdded = 0; // Keep track of how many valid days we've added

    // Helper function to check if the current date is in the 'twoo' array
    function isInTwoo(date) {
      let dateStr = date.toLocaleDateString("en-GB"); // Format date as 'DD/MM/YYYY'
      return twoo.includes(dateStr);
    }

    while (daysAdded < count) {
      currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
      let dayOfWeek = currentDate.getDay(); // 0 is Sunday, 6 is Saturday

      // Skip Sundays
      if (dayOfWeek === 0) {
        continue;
      }

      // Skip all Saturdays
      if (dayOfWeek === 6) {
        continue;
      }

      // Skip dates in the 'twoo' array
      if (isInTwoo(currentDate)) {
        continue;
      }

      daysAdded++; // Only increment if it's a valid day (not skipped)
    }

    return currentDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }

  let Redirect = async() => {
    navigate("/monthlyreport");
  }


  return (
    <div>
      <div className="row">
        <Header />
        <div className="col-10">
          <div className="d-flex justify-content-between">
            <h1 style={{ textAlign: "center" }}>Report</h1>
            <button style={{ fontSize : 12 , height :  40 , marginRight :  10 , marginTop :  10 }} onClick={()=>{ Redirect() }}>Monthly Report</button>
          </div>
          {/* 
          <div className="row">
            <div className="col-3">
              
            </div>

            <div className="col-3">
              
              <input
                onChange={(e) => {
                  setStartdate(e.target.value);
                }}
                type="date"
              />
              <p>select start date</p>
            </div>
            <div className="col-3">
              
              <input
                type="date"
                onChange={(e) => {
                  setEnddate(e.target.value);
                }}
              />
              <p>select end date</p>
            </div>
 
          </div> */}


          <div className="row" >
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }} >
              <p>Today Users</p>
              <p>{data?.todayusercount || 0}</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }} >
              <p>Yesterday Users</p>
              <p>{data?.user || 0}</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }} >
              <p>Freezed <span style={{ color: 'red' }}>{data?.allfrezeeco}</span></p>
              <p>₹ {data?.allfre_Total || 0}</p>
            </div>


            <div className="col-3" style={{ border: "1px solid #ddd", padding: "10px", color: 'orange', fontWeight: "700" }} >
              <p>Chargeback</p>
              <p>₹ {data?.chargeback}</p>
            </div>





            
            <div className="col-3" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}  >
              <p>Today Settlement Pending</p>
              <p>
                <p>₹ {data?.settle_pending}</p>
              </p>
            </div>

           

            <div className="col-3" style={{ border: "1px solid #ddd", padding: "10px", color: 'orange', fontWeight: "700" }} >
              <p>Overall Settlement Pending</p>
              <p>₹ {data?.overall_pending}</p>

            </div>
          </div>

          <div className="row mt-4" >
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }} >

            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }} >
              <p>Today {'(' + addWorkingDay(0, leave) + ')'}</p>


            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }} >
              <p>T1 {'(' + newaddWorkingDayt3(1, leave) + ')'}</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>T2 {'(' + newaddWorkingDayt3(2, leave) + ')'}</p>
            </div> 
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>T3 {'(' + newaddWorkingDayt3(3, leave) + ')'}</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>T4 {'(' + newaddWorkingDayt3(4, leave) + ')'}</p>
            </div>


            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>Settlement</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              {data?.samedaycount}
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              {data?.t1count}
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }} >
              {data?.t2count}
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              {data?.t3count}
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              {data?.t4count}
            </div>


            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }} >
              <p>Amount</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }} >
              ₹ {data?.settle_pending}

              {
                ["sameday"]?.map((dt, index) => {

                  let sacont = 0
                  let saamount = 0

                  let t1cont = 0
                  let t1amount = 0

                  let t2cont = 0
                  let t2amount = 0

                  let t3cont = 0
                  let t3amount = 0

                  let t4cont = 0
                  let t4amount = 0

                  let lowcont = 0
                  let lowamount = 0

                  data?.samedatedata?.map((dt, index) => {

                    let jsonvalueee = JSON.parse(dt.charge)

                    console.log(jsonvalueee?.title, "jsonvalueee")

                    if (jsonvalueee?.title === "Sameday" || jsonvalueee?.title === "Instant") {
                      sacont = sacont + 1
                      saamount = saamount + Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "T1") {
                      t1cont = t1cont + 1
                      t1amount = t1amount +  Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "T2") {
                      t2cont = t2cont + 1
                      t2amount = t2amount +  Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "T3") {
                      t3cont = t3cont + 1
                      t3amount = t3amount +  Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "T4") {
                      t4cont = t4cont + 1
                      t4amount = t4amount +  Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "Low") {
                      lowcont = lowcont + 1
                      lowamount = lowamount +  Number(dt.amount)
                    }

                  })


                  return (
                    <>
                      <div style={{ marginTop: 15, }} className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >Sameday</p>
                        </div>
                        <div className="col-4" >
                          <p style={{   fontSize: 12, color: 'red' }} >{sacont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{   fontSize: 12, color: 'red' }} >{saamount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >T1</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t1cont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t1amount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{   fontSize: 12 }} >T2</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t2cont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t2amount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >T3</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t3cont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t3amount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >T4</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t4cont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t4amount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >Low</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{lowcont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{lowamount}</p>
                        </div>
                      </div>


                      

                    </>
                  )
                })

              }

            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }} >
               ₹ {data?.t1overview}

              {
                ["sameday"]?.map((dt, index) => {

                  let sacont = 0
                  let saamount = 0

                  let t1cont = 0
                  let t1amount = 0

                  let t2cont = 0
                  let t2amount = 0

                  let t3cont = 0
                  let t3amount = 0

                  let t4cont = 0
                  let t4amount = 0

                  let lowcont = 0
                  let lowamount = 0

                  data?.t1data?.map((dt, index) => {

                    let jsonvalueee = JSON.parse(dt.charge)

                    console.log(jsonvalueee?.title, "jsonvalueee")

                    if (jsonvalueee?.title === "Sameday" || jsonvalueee?.title === "Instant") {
                      sacont = sacont + 1
                      saamount = saamount + Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "T1") {
                      t1cont = t1cont + 1
                      t1amount = t1amount +  Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "T2") {
                      t2cont = t2cont + 1
                      t2amount = t2amount +  Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "T3") {
                      t3cont = t3cont + 1
                      t3amount = t3amount +  Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "T4") {
                      t4cont = t4cont + 1
                      t4amount = t4amount +  Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "Low") {
                      lowcont = lowcont + 1
                      lowamount = lowamount +  Number(dt.amount)
                    }

                  })


                  return (
                    <>
                      <div style={{ marginTop: 15, }} className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >Today</p>
                        </div>
                        <div className="col-4" >
                          <p style={{   fontSize: 12, color: 'red' }} >{sacont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{   fontSize: 12, color: 'red' }} >{saamount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >T1</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t1cont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t1amount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{   fontSize: 12 }} >T2</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t2cont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t2amount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >T3</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t3cont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t3amount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >T4</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t4cont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t4amount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >Low</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{lowcont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{lowamount}</p>
                        </div>
                      </div>

                    </>
                  )
                })

              }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }} >
               ₹ {data?.t2overview}

              {
                ["sameday"]?.map((dt, index) => {

                  let sacont = 0
                  let saamount = 0

                  let t1cont = 0
                  let t1amount = 0

                  let t2cont = 0
                  let t2amount = 0

                  let t3cont = 0
                  let t3amount = 0

                  let t4cont = 0
                  let t4amount = 0

                  let lowcont = 0
                  let lowamount = 0

                  data?.t2data?.map((dt, index) => {

                    let jsonvalueee = JSON.parse(dt.charge)

                    console.log(jsonvalueee?.title, "jsonvalueee")

                    if (jsonvalueee?.title === "Sameday" || jsonvalueee?.title === "Instant") {
                      sacont = sacont + 1
                      saamount = saamount + Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "T1") {
                      t1cont = t1cont + 1
                      t1amount = t1amount +  Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "T2") {
                      t2cont = t2cont + 1
                      t2amount = t2amount +  Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "T3") {
                      t3cont = t3cont + 1
                      t3amount = t3amount +  Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "T4") {
                      t4cont = t4cont + 1
                      t4amount = t4amount +  Number(dt.amount)
                    }


                    if (jsonvalueee?.title === "Low") {
                      lowcont = lowcont + 1
                      lowamount = lowamount +  Number(dt.amount)
                    }

                  })


                  return (
                    <>
                      <div style={{ marginTop: 15, }} className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >Sameday</p>
                        </div>
                        <div className="col-4" >
                          <p style={{   fontSize: 12, color: 'red' }} >{sacont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{   fontSize: 12, color: 'red' }} >{saamount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >T1</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t1cont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t1amount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{   fontSize: 12 }} >T2</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t2cont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t2amount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >T3</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t3cont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t3amount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >T4</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t4cont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t4amount}</p>
                        </div>
                      </div>


                      <div className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >Low</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{lowcont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{lowamount}</p>
                        </div>
                      </div>

                    </>
                  )
                })

              }


            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
               ₹ {data?.t3overview}

              {
                ["sameday"]?.map((dt, index) => {

                  let sacont = 0
                  let saamount = 0

                  let t1cont = 0
                  let t1amount = 0

                  let t2cont = 0
                  let t2amount = 0

                  let t3cont = 0
                  let t3amount = 0

                  let t4cont = 0
                  let t4amount = 0

                  let lowcont = 0
                  let lowamount = 0

                  data?.t3data?.map((dt, index) => {

                    let jsonvalueee = JSON.parse(dt.charge)

                    console.log(jsonvalueee?.title, "jsonvalueee")

                    if (jsonvalueee?.title === "Sameday" || jsonvalueee?.title === "Instant") {
                      sacont = sacont + 1
                      saamount = saamount + Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "T1") {
                      t1cont = t1cont + 1
                      t1amount = t1amount +  Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "T2") {
                      t2cont = t2cont + 1
                      t2amount = t2amount +  Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "T3") {
                      t3cont = t3cont + 1
                      t3amount = t3amount +  Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "T4") {
                      t4cont = t4cont + 1
                      t4amount = t4amount +  Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "Low") {
                      lowcont = lowcont + 1
                      lowamount = lowamount +  Number(dt.amount)
                    }

                  })


                  return (
                    <>
                      <div style={{ marginTop: 15, }} className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >Sameday</p>
                        </div>
                        <div className="col-4" >
                          <p style={{   fontSize: 12, color: 'red' }} >{sacont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{   fontSize: 12, color: 'red' }} >{saamount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >T1</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t1cont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t1amount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{   fontSize: 12 }} >T2</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t2cont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t2amount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >T3</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t3cont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t3amount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >T4</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t4cont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t4amount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >Low</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{lowcont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{lowamount}</p>
                        </div>
                      </div>

                    </>
                  )
                })

              }


            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
               ₹ {data?.t4overview}


              {
                ["sameday"]?.map((dt, index) => {

                  let sacont = 0
                  let saamount = 0

                  let t1cont = 0
                  let t1amount = 0

                  let t2cont = 0
                  let t2amount = 0

                  let t3cont = 0
                  let t3amount = 0

                  let t4cont = 0
                  let t4amount = 0

                  let lowcont = 0
                  let lowamount = 0

                  data?.t4data?.map((dt, index) => {

                    let jsonvalueee = JSON.parse(dt.charge)

                    console.log(jsonvalueee?.title, "jsonvalueee")

                    if (jsonvalueee?.title === "Sameday" || jsonvalueee?.title === "Instant") {
                      sacont = sacont + 1
                      saamount = saamount + Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "T1") {
                      t1cont = t1cont + 1
                      t1amount = t1amount +  Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "T2") {
                      t2cont = t2cont + 1
                      t2amount = t2amount +  Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "T3") {
                      t3cont = t3cont + 1
                      t3amount = t3amount +  Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "T4") {
                      t4cont = t4cont + 1
                      t4amount = t4amount +  Number(dt.amount)
                    }

                    if (jsonvalueee?.title === "Low") {
                      lowcont = lowcont + 1
                      lowamount = lowamount +  Number(dt.amount)
                    }

                  })


                  return (
                    <>
                      <div style={{ marginTop: 15, }} className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >Sameday</p>
                        </div>
                        <div className="col-4" >
                          <p style={{   fontSize: 12, color: 'red' }} >{sacont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{   fontSize: 12, color: 'red' }} >{saamount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >T1</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t1cont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t1amount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{   fontSize: 12 }} >T2</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t2cont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t2amount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >T3</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t3cont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t3amount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >T4</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t4cont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{t4amount}</p>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-4" >
                          <p style={{ fontSize: 12 }} >Low</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{lowcont}</p>
                        </div>
                        <div className="col-4" >
                          <p style={{ fontSize: 12, color: 'red' }} >{lowamount}</p>
                        </div>
                      </div>

                    </>
                  )
                })

              }
            </div>
          </div>


          <div className="row mt-4" >
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }} >
              <p style={{ color: 'red' }}>Yesterday payment</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }} >
              <p>Sameday </p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }} >
              <p>T1  </p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>T2 </p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>T3</p>
            </div>
            <div className="col-1" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>T4</p>
            </div>
             <div className="col-1" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>Low</p>
            </div>


            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>Utility {"("} {data?.UtilityTotal?.length} {")"}</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              {
                data?.UtilityTotal
                  ?.reduce((acc, item) => {
                    let d = JSON.parse(item.charge);
                    return d?.title === "Sameday" ? acc + 1 : acc;
                  }, 0)
              }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              {
                data?.UtilityTotal
                  ?.reduce((acc, item) => {
                    let d = JSON.parse(item.charge);
                    return d?.title === "T1" ? acc + 1 : acc;
                  }, 0)
              }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }} >
              {
                data?.UtilityTotal
                  ?.reduce((acc, item) => {
                    let d = JSON.parse(item.charge);
                    return d?.title === "T2" ? acc + 1 : acc;
                  }, 0)
              }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              {
                data?.UtilityTotal
                  ?.reduce((acc, item) => {
                    let d = JSON.parse(item.charge);
                    return d?.title === "T3" ? acc + 1 : acc;
                  }, 0)
              }
            </div>
            <div className="col-1" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              {
                data?.UtilityTotal
                  ?.reduce((acc, item) => {
                    let d = JSON.parse(item.charge);
                    return d?.title === "T4" ? acc + 1 : acc;
                  }, 0)
              }
            </div> 
            <div className="col-1" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
          
            </div> 


            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }} >
              <p>Education {"("} {data?.EduTotal?.length} {")"}</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }} >
              {
                data?.EduTotal?.reduce((acc, item) => {
                  let d = JSON.parse(item.charge);
                  return d?.title === "Sameday" ? acc + 1 : acc;
                }, 0)
              }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }} >
              {
                data?.EduTotal?.reduce((acc, item) => {
                  let d = JSON.parse(item.charge);
                  return d?.title === "T1" ? acc + 1 : acc;
                }, 0)
              }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }} >
              {
                data?.EduTotal?.reduce((acc, item) => {
                  let d = JSON.parse(item.charge);
                  return d?.title === "T2" ? acc + 1 : acc;
                }, 0)
              }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              {
                data?.EduTotal?.reduce((acc, item) => {
                  let d = JSON.parse(item.charge);
                  return d?.title === "T3" ? acc + 1 : acc;
                }, 0)
              }
            </div>
            <div className="col-1" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              {
                data?.EduTotal?.reduce((acc, item) => {
                  let d = JSON.parse(item.charge);
                  return d?.title === "T4" ? acc + 1 : acc;
                }, 0)
              }
            </div>
            <div className="col-1" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              {
                data?.EduTotal?.reduce((acc, item) => {
                  let d = JSON.parse(item.charge);
                  return d?.title === "Low" ? acc + 1 : acc;
                }, 0)
              }
            </div>
          </div>


          {/* <div className="row mt-4" >
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }} >
              <p style={{ color: 'red' }}>Today payment</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }} >
              <p>Sameday </p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }} >
              <p>T1  </p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>T2 </p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>T3</p>
            </div>
            <div className="col-1" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>T4</p>
            </div>
             <div className="col-1" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>Low</p>
            </div>


            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }}>
              <p>Utility {"("} {data?.UtilityTotal?.length} {")"}</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              {
                data?.UtilityTotal
                  ?.reduce((acc, item) => {
                    let d = JSON.parse(item.charge);
                    return d?.title === "Sameday" ? acc + 1 : acc;
                  }, 0)
              }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              {
                data?.UtilityTotal
                  ?.reduce((acc, item) => {
                    let d = JSON.parse(item.charge);
                    return d?.title === "T1" ? acc + 1 : acc;
                  }, 0)
              }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }} >
              {
                data?.UtilityTotal
                  ?.reduce((acc, item) => {
                    let d = JSON.parse(item.charge);
                    return d?.title === "T2" ? acc + 1 : acc;
                  }, 0)
              }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              {
                data?.UtilityTotal
                  ?.reduce((acc, item) => {
                    let d = JSON.parse(item.charge);
                    return d?.title === "T3" ? acc + 1 : acc;
                  }, 0)
              }
            </div>
            <div className="col-1" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              {
                data?.UtilityTotal
                  ?.reduce((acc, item) => {
                    let d = JSON.parse(item.charge);
                    return d?.title === "T4" ? acc + 1 : acc;
                  }, 0)
              }
            </div> 
            <div className="col-1" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
          
            </div> 


            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", fontWeight: "700" }} >
              <p>Education {"("} {data?.EduTotal?.length} {")"}</p>
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }} >
              {
                data?.EduTotal?.reduce((acc, item) => {
                  let d = JSON.parse(item.charge);
                  return d?.title === "Sameday" ? acc + 1 : acc;
                }, 0)
              }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }} >
              {
                data?.EduTotal?.reduce((acc, item) => {
                  let d = JSON.parse(item.charge);
                  return d?.title === "T1" ? acc + 1 : acc;
                }, 0)
              }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }} >
              {
                data?.EduTotal?.reduce((acc, item) => {
                  let d = JSON.parse(item.charge);
                  return d?.title === "T2" ? acc + 1 : acc;
                }, 0)
              }
            </div>
            <div className="col-2" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              {
                data?.EduTotal?.reduce((acc, item) => {
                  let d = JSON.parse(item.charge);
                  return d?.title === "T3" ? acc + 1 : acc;
                }, 0)
              }
            </div>
            <div className="col-1" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              {
                data?.EduTotal?.reduce((acc, item) => {
                  let d = JSON.parse(item.charge);
                  return d?.title === "T4" ? acc + 1 : acc;
                }, 0)
              }
            </div>
            <div className="col-1" style={{ border: "1px solid #ddd", padding: "10px", color: 'green', fontWeight: "700" }}>
              {
                data?.EduTotal?.reduce((acc, item) => {
                  let d = JSON.parse(item.charge);
                  return d?.title === "Low" ? acc + 1 : acc;
                }, 0)
              }
            </div>
          </div> */}


          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
